
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Toplu işlem sayfalarında (ve gerekirse başka kısıtlı sayfalarda) kullanım süresi
 * dolduğunda sayfayı kilitleyen overlay. Sayfanın kök elemanının (genelde v-row)
 * ilk child'ı olarak yerleştirilir; `absolute` ile tüm sayfayı kaplar.
 *
 * Kök eleman `position: relative` değilse overlay tüm viewport'a yayılabilir; bu
 * yüzden sarmalayan sayfaya `position: relative` veren `lisans-overlay-host` class'ı
 * eklenmelidir (aşağıdaki global stil sağlar).
 */
@Component
export default class LisansSuresiOverlay extends Vue {
  /** Süre-dolu mesajı (özelleştirilebilir). */
  @Prop({ default: "Kullanım süreniz dolduğu için bu işlem yapılamaz." })
  mesaj!: string;

  get suresiDoldu(): boolean {
    return this.$helper.icraSuresiDoldu();
  }
}
